module.exports = __webpack_public_path__ + "static/media/hero1.eae12733.png";